import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Portfolio Analysis'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      addPmmMeterPmmMeterAccountIdUnitIdPost: build.mutation<
        AddPmmMeterPmmMeterAccountIdUnitIdPostApiResponse,
        AddPmmMeterPmmMeterAccountIdUnitIdPostApiArg
      >({
        query: (queryArg) => ({
          url: `/pmm_meter/${queryArg.accountId}/${queryArg.unitId}`,
          method: 'POST',
          params: {
            meter_type: queryArg.meterType,
            postal_code: queryArg.postalCode,
            street: queryArg.street,
            building_number: queryArg.buildingNumber,
            city: queryArg.city,
            matrikel_key: queryArg.matrikelKey,
            display_name: queryArg.displayName,
          },
        }),
        invalidatesTags: ['Portfolio Analysis'],
      }),
      removePmmMeterPmmMeterAccountIdUnitIdDelete: build.mutation<
        RemovePmmMeterPmmMeterAccountIdUnitIdDeleteApiResponse,
        RemovePmmMeterPmmMeterAccountIdUnitIdDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/pmm_meter/${queryArg.accountId}/${queryArg.unitId}`,
          method: 'DELETE',
          params: {
            meter_type: queryArg.meterType,
          },
        }),
        invalidatesTags: ['Portfolio Analysis'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type AddPmmMeterPmmMeterAccountIdUnitIdPostApiResponse =
  /** status 201 Successful Response */ number;
export type AddPmmMeterPmmMeterAccountIdUnitIdPostApiArg = {
  /** The ReCalc account id to add the meter to. */
  accountId: number;
  /** The ReCalc unit id of the PMM meter to add. */
  unitId: number;
  /** The type of PMM meter to add. */
  meterType: PmMeterType;
  /** The zip code of the meter address. */
  postalCode: number;
  /** The street name of the meter address. */
  street: string;
  /** The street number of the meter address. */
  buildingNumber: string;
  /** The city of the meter address. */
  city?: string | null;
  /** Optional matrikel key to associate with the meter. */
  matrikelKey?: string | null;
  /** Optional display name for the meter. */
  displayName?: string | null;
};
export type RemovePmmMeterPmmMeterAccountIdUnitIdDeleteApiResponse =
  /** status 200 Successful Response */ number;
export type RemovePmmMeterPmmMeterAccountIdUnitIdDeleteApiArg = {
  /** The ReCalc account id to remove the meter from. */
  accountId: number;
  /** The ReCalc unit id of the PMM meter to remove. */
  unitId: number;
  /** The type of PMM meter to remove. */
  meterType: PmMeterType;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type PmMeterType = 'solar_panels' | 'heat_pump' | 'power_meter';
export const {
  useAddPmmMeterPmmMeterAccountIdUnitIdPostMutation,
  useRemovePmmMeterPmmMeterAccountIdUnitIdDeleteMutation,
} = injectedRtkApi;
